export function isNull(obj: any | null): obj is null {
    return obj !== null
}